// Task API — board/kanban feature. The interactive board ships in the
// workspace unit; this typed wrapper is built now (per the API contract)
// so that unit doesn't need a new API file, only UI.
import { apiFetch } from './client';
import type { Task } from '$lib/types';

export const tasksApi = {
  forProject: (projectId: number) => apiFetch<{ results: Task[]; count: number }>(`/projects/${projectId}/tasks`),
  create: (projectId: number, body: { title: string; desc?: string; col?: string; tag?: string; assignee_user_id?: number | null }) =>
    apiFetch<Task>(`/projects/${projectId}/tasks`, { method: 'POST', body: JSON.stringify(body) }),
  update: (
    id: number,
    body: Partial<{ title: string; desc: string; col: string; tag: string; assignee_user_id: number | null }>
  ) => apiFetch<Task>(`/tasks/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/tasks/${id}`, { method: 'DELETE' })
};
